import React from "react";
import { Layout } from "../../layout/PortalLayout/PortalLayout";

const Dashboard = () => {
  return (
    <Layout>
      <h2 className="d-flex justify-content-center">
        Admin Portal - Dashboard
      </h2>
    </Layout>
  );
};

export default Dashboard;
